import {
  FrameConnector,
  HostActionsHandler,
  FrameActions,
  timeout,
  updateHeight,
} from "@govtechsg/decentralized-renderer-react-components";
import react, { useCallback, useState, useEffect } from "react";
import { isActionOf } from "typesafe-actions";
import { WrappedDocument } from "@govtechsg/open-attestation/dist/types/2.0/types";
import { getData } from "@govtechsg/open-attestation";

type Document = {
  name: string;
  document: WrappedDocument;
  frameSource: string;
};

interface ViewerProps {
  document: Document;
}

const Viewer: React.FC<ViewerProps> = ({ document }) => {
  const [toFrame, setToFrame] = useState<HostActionsHandler>();
  const [height, setHeight] = useState(250);

  const fn = useCallback((toFrame: HostActionsHandler) => {
    // wrap into a function otherwise toFrame function will be executed
    setToFrame(() => toFrame);
  }, []);

  const fromFrame = (action: FrameActions): void => {
    if (isActionOf(updateHeight, action)) {
      setHeight(action.payload);
    }
    if (isActionOf(timeout, action)) {
      alert(
        `Connection timeout on renderer.\nPlease contact the administrator of ${document.frameSource}.`
      );
    }
  };

  // eslint-disable-next-line @typescript-eslint/ban-ts-comment
  // @ts-ignore
  // window.renderDocument = (document) => {
  //   if (toFrame && document) {
  //     toFrame({
  //       type: "RENDER_DOCUMENT",
  //       payload: {
  //         document,
  //       },
  //     });
  //   }
  // };

  useEffect(() => {
    if (toFrame) {
      toFrame({
        type: "RENDER_DOCUMENT",
        payload: {
          document: getData(document.document),
        },
      });
    }
  }, [toFrame, document]);

  return (
    <FrameConnector
      source={document.frameSource}
      dispatch={fromFrame}
      onConnected={fn}
      className="h-[46rem] w-[66rem]"
    />
  );
};

export default Viewer;
